import React from 'react'

export default function Inspirations() {
    return (
        <div>
            <h1>Hello from Inspirations Component</h1>
        </div>
    )
}